(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9629],{

/***/ 319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Content_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9756);
/* harmony import */ var _Content_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Content_module_css__WEBPACK_IMPORTED_MODULE_2__);
// import node_modules



// import styles

// define component
var ContentComponent = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content_module_css__WEBPACK_IMPORTED_MODULE_2___default().content),
        dangerouslySetInnerHTML: {
            __html: children
        }
    });
};
ContentComponent.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentComponent);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 8108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ elements_NewsletterSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./src/types/index.ts + 5 modules
var types = __webpack_require__(6198);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/use-immer/dist/use-immer.module.js
var use_immer_module = __webpack_require__(57);
// EXTERNAL MODULE: ./node_modules/jotai-immer/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(8387);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/notifications/dist/index.modern.js + 1 modules
var dist_index_modern = __webpack_require__(1663);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/modules/jotai/index.ts + 1 modules
var jotai = __webpack_require__(1262);
// EXTERNAL MODULE: ./src/modules/utils/is-email.ts
var is_email = __webpack_require__(3733);
// EXTERNAL MODULE: ./src/components/forms/NewsletterForm.module.css
var NewsletterForm_module = __webpack_require__(4788);
var NewsletterForm_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterForm_module);
;// CONCATENATED MODULE: ./src/components/forms/NewsletterForm.tsx
// import node_modules











// import types

// import modules


// import styles

// define component
var NewsletterFormComponent = function() {
    // init state
    var _useImmer = (0,_sliced_to_array/* default */.Z)((0,use_immer_module/* useImmer */.x)(""), 2), inputState = _useImmer[0], setInputState = _useImmer[1];
    var _useImmer1 = (0,_sliced_to_array/* default */.Z)((0,use_immer_module/* useImmer */.x)(null), 2), errorState = _useImmer1[0], setErrorState = _useImmer1[1];
    var _useImmer2 = (0,_sliced_to_array/* default */.Z)((0,use_immer_module/* useImmer */.x)(false), 2), loadingState = _useImmer2[0], setLoadingState = _useImmer2[1];
    // init hooks
    var _useImmerAtom = (0,_sliced_to_array/* default */.Z)((0,index_modern/* useImmerAtom */.It)(jotai/* localeAtom */.S$), 1), locale = _useImmerAtom[0];
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)("components").t;
    var subscribeToNewsletterWithDoubleOptin = (0,dist_index_modern/* useNotifications */.z)().subscribeToNewsletterWithDoubleOptin;
    // define methods
    var onChange = react.useCallback(function(event) {
        setInputState(event.target.value);
    }, [
        setInputState
    ]);
    var onSubmit = react.useCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _ref, error, success, isDE, thankYouPage, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        // show spinner
                        setLoadingState(true);
                        // check email
                        if (!(0,is_email/* isEmail */.J)(inputState)) {
                            setErrorState(t("EarlyAccessForm.email.error"));
                            setLoadingState(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // reset error
                        setErrorState(null);
                        return [
                            4,
                            subscribeToNewsletterWithDoubleOptin({
                                email: inputState,
                                locale: locale
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), error = _ref.error, success = _ref.success;
                        // check error
                        if (error || !success) {
                            throw new Error("Subscription failed!");
                        }
                        isDE = locale === "de";
                        thankYouPage = isDE ? types/* RouteEnum.WEBSITE_NEWSLETTER_THANK_YOU_DE */.gv.WEBSITE_NEWSLETTER_THANK_YOU_DE : types/* RouteEnum.WEBSITE_NEWSLETTER_THANK_YOU_EN */.gv.WEBSITE_NEWSLETTER_THANK_YOU_EN;
                        router.push(thankYouPage);
                        // hide spinner and close modal
                        setLoadingState(false);
                        setInputState("");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error1 = _state.sent();
                        setErrorState(t("EarlyAccessForm.submit.error"));
                        setLoadingState(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        inputState,
        locale,
        router,
        setErrorState,
        setInputState,
        setLoadingState,
        subscribeToNewsletterWithDoubleOptin,
        t
    ]);
    var onKeyDown = react.useCallback(function(event) {
        // handle return
        if (event.key === "Enter") {
            event.preventDefault();
            onSubmit(event);
        }
    }, [
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NewsletterForm_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NewsletterForm_module_default())["form-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_esm/* Form */.l0, {
                    formId: "storyliner-newsletter-form",
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NewsletterForm_module_default())["input-container"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Input */.II, {
                                    customInputClasses: (NewsletterForm_module_default()).input,
                                    customLabelClasses: (NewsletterForm_module_default()).label,
                                    formId: "storyliner-newsletter-form",
                                    inputId: "storyliner-newsletter-form-intput",
                                    inputName: "storyliner-newsletter-form-intput",
                                    onChange: onChange,
                                    onKeyDown: onKeyDown,
                                    placeholder: t("NewsletterForm.email.placeholder"),
                                    type: "email",
                                    value: inputState
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Button */.zx, {
                                    color: "dark",
                                    customClasses: (NewsletterForm_module_default()).button,
                                    formId: "storyliner-newsletter-form",
                                    isLoading: loadingState,
                                    size: "large",
                                    text: t("NewsletterForm.submit.label"),
                                    type: "submit"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewsletterForm_module_default()).error,
                            children: errorState && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                isError: true,
                                children: errorState
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NewsletterForm_module_default())["privacy-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* RemixIcon */.zS, {
                        customClasses: (NewsletterForm_module_default())["privacy-icon"],
                        iconName: "ri-lock-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Tooltip */.u, {
                        placement: "top",
                        content: t("NewsletterForm.privacy.tooltip"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                            size: "small",
                            isHelpText: true,
                            children: t("NewsletterForm.privacy.text")
                        })
                    })
                ]
            })
        ]
    });
};
NewsletterFormComponent.displayName = "NewsletterForm";
/* harmony default export */ var NewsletterForm = (NewsletterFormComponent);

// EXTERNAL MODULE: ./src/components/atoms/Section.tsx
var Section = __webpack_require__(9748);
// EXTERNAL MODULE: ./src/components/elements/NewsletterSection.module.css
var NewsletterSection_module = __webpack_require__(1160);
var NewsletterSection_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterSection_module);
;// CONCATENATED MODULE: ./src/components/elements/NewsletterSection.tsx
// import node_modules





// import types

// import components


// import styles

// define component
var NewsletterSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var t = (0,useTranslation/* useTranslation */.$)("components").t;
    // render section
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NewsletterSection_module_default())["storyliner-newsletter-section-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NewsletterSection_module_default())["storyliner-newsletter-section-header"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("NewsletterSection.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                            alignment: "center",
                            children: t("NewsletterSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterForm, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewsletterSection_module_default())["storyliner-newsletter-section-scribble"]
                })
            ]
        })
    });
};
NewsletterSection.defaultProps = {
    bgColor: "white"
};
NewsletterSection.propTypes = {
    bgColor: prop_types.oneOf(Object.values(types/* SectionColorEnum */.TJ))
};
/* harmony default export */ var elements_NewsletterSection = (NewsletterSection);


/***/ }),

/***/ 6009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4090);
/* eslint-disable jsx-a11y/alt-text */ // import node_modules



// import types

// import components



// define component
var LogosGrid = function(param) {
    var bgColor = param.bgColor, logos = param.logos;
    // init vars
    var isBlack = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return bgColor === _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionColorEnum.energyYellow */ .TJ.energyYellow;
    }, [
        bgColor
    ]);
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        mobileFlexDirection: "row",
        zIndex: 1,
        children: logos === null || logos === void 0 ? void 0 : logos.map(function(logo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                cols: 5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    height: 360,
                    title: logo.alt,
                    isWhite: !isBlack,
                    isBlack: isBlack,
                    imageId: logo.src,
                    width: 720
                })
            }, logo.src);
        })
    });
};
LogosGrid.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_2__/* .SectionColorEnum */ .TJ)).isRequired,
    logos: prop_types__WEBPACK_IMPORTED_MODULE_6__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_6__.shape({
        alt: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
        src: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LogosGrid);


/***/ }),

/***/ 3441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7058);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _atoms_Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(319);
/* harmony import */ var _grids_LogosGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6009);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6880);
/* harmony import */ var _elements_NewsletterSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8108);
/* harmony import */ var _meta_SEO__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8897);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9748);
/* harmony import */ var _atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4090);
// import node_modules





// import components








// define page component
var AboutTemplate = function(param) {
    var hrefLang = param.hrefLang;
    // init hooks
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$)("about").t;
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_meta_SEO__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                description: t("seo.description"),
                hrefLang: hrefLang,
                image: t("seo.image"),
                title: t("seo.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                mobileHeight: "25px",
                                tabletHeight: "50px",
                                height: "75px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            cols: "ml",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                alignment: "center",
                                tag: "h1",
                                isHyphenated: false,
                                children: t("hero.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "16px",
                            tabletHeight: "16px",
                            height: "16px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                imageId: t("team.image.src"),
                                height: 611,
                                title: t("team.image.alt"),
                                width: 1438
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "16px",
                            tabletHeight: "16px",
                            height: "16px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            cols: "md",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Content__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                children: t("brandStory")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                alignment: "center",
                                tag: "label",
                                isWhite: true,
                                children: t("partners.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_grids_LogosGrid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        bgColor: "allports",
                        logos: t("partners.logos", {
                            returnObjects: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgImage: t("partners.dividerBottom"),
                        bgImageDark: t("partners.dividerBottomDark"),
                        bgPosition: "center bottom",
                        zIndex: 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "100px",
                            tabletHeight: "125px",
                            height: "150px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        sectionId: "jobs",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            cols: "md",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                    alignment: "center",
                                    tag: "h2",
                                    isHyphenated: false,
                                    children: t("jobs.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    alignment: "center",
                                    children: t("jobs.text")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            cols: "md",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                alignment: "center",
                                isItalic: true,
                                children: t("jobs.noJobs")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_NewsletterSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        bgColor: "desertStorm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "50px"
                        })
                    })
                ]
            })
        ]
    });
};
AboutTemplate.propTypes = {
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_12__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (AboutTemplate);


/***/ }),

/***/ 9756:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"storyliner-CKbkg8","responsive-iframe":"storyliner-7RxrfO","iframe-wrapper":"storyliner-Gja7zP","optin-canvas":"storyliner-hrBBek","info-text":"storyliner-FMSQUL","icon-wrapper":"storyliner-JVx0j2","optin-button":"storyliner-iD5V57"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 1160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-newsletter-section-scribble":"storyliner-Zl5Q2W","storyliner-newsletter-section-header":"storyliner-NEEnY1","storyliner-newsletter-section-container":"storyliner-2PA31M"};

/***/ }),

/***/ 4788:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"storyliner-rvDRgS","form-container":"storyliner-R6jjlV","input-container":"storyliner-70CKwA","input":"storyliner-Yp6Syx","label":"storyliner-K9Ocob","button":"storyliner-EIuyW1","error":"storyliner-m90YpQ","privacy-container":"storyliner-schH0f","privacy-icon":"storyliner-vHlPyt"};

/***/ })

}]);